(() => {
  const context = document.querySelector('[data-siti-request-intro]');
  const heading = document.querySelector('[id$="__rich_text_gpiRkw"] h1');
  if (!context || !heading || heading.closest('form, [data-siti-mailblue]')) return;
  const source = context.querySelector('[data-siti-request-copy]');
  if (!source) return;
  const copy = JSON.parse(source.textContent);
  const params = new URLSearchParams(window.location.search);
  const model = { 'Athlete-Pro': 'Athlete · Pro', 'Care-Pro': 'Care · Pro', Care: 'Care', Opus: 'Opus', Oris: 'Oris' }[params.get('model')];
  if (params.get('onderwerp') === 'Sit-i-Return') {
    heading.textContent = copy.return;
    const intro = document.querySelector('[id$="__rich_text_gpiRkw"] .rte');
    if (intro) intro.textContent = copy.returnIntro;
  }
  else if (params.get('aanvraag') === 'lease') heading.textContent = copy.lease;
  else if (['Flow-Analyst', 'Movement-Expert'].includes(params.get('opleiding'))) heading.textContent = copy.academy;
  else if (model) heading.textContent = copy.quote.replace('{model}', model);
  else if (params.get('model') === 'Productadvies') heading.textContent = copy.advice;
  const quoteRequest = Boolean(model) && !params.get('opleiding') && !params.get('aanvraag') && !['reserve','reservation'].includes(params.get('type'));
  if (!quoteRequest || !copy.quoteIntro || !copy.formButton) return;
  const intro = document.querySelector('[id$="__rich_text_gpiRkw"] .rte');
  if (intro) intro.textContent = copy.quoteIntro.replace('{model}', model);
  const contactSection = document.querySelector('[data-siti-mailblue]');
  if (!contactSection) return;
  const applyVisibleQuoteText = () => {
    const title = contactSection.querySelector('[data-siti-context-title]');
    const description = contactSection.querySelector('[data-siti-context-description]');
    const kicker = contactSection.querySelector('[data-siti-context-kicker]');
    if (title && title.textContent !== copy.formTitle) title.textContent = copy.formTitle;
    if (description && description.textContent !== copy.formDescription) description.textContent = copy.formDescription;
    if (kicker && kicker.textContent !== copy.formKicker) kicker.textContent = copy.formKicker;
    const button = contactSection.querySelector('#sit-i-contact form button[type="submit"]');
    if (button && !button.disabled && ['Stuur mijn bericht', 'Send my message', 'Send message', 'Verstuur', 'Submit'].includes(button.textContent.trim())) button.textContent = copy.formButton;
  };
  applyVisibleQuoteText();
  new MutationObserver(applyVisibleQuoteText).observe(contactSection, { childList: true, subtree: true, characterData: true });
})();
